import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';
import { translate } from 'react-i18next';
import Moment from 'react-moment';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { Link } from 'react-router-dom';
import {print} from 'react-icons-kit/fa/print';
import SvgIcon from 'react-icons-kit';
import {pencil2} from 'react-icons-kit/icomoon/pencil2';
import {checkmark} from 'react-icons-kit/icomoon/checkmark';
import {cross} from 'react-icons-kit/icomoon/cross';
import {minus} from 'react-icons-kit/icomoon/minus';
import {clipboard} from 'react-icons-kit/icomoon/clipboard';
import ModalSingleValidation from '../../validation_donation/components/ModalSingleValidation';
import WaitingModal from '../../generics/WaitingModal';
import ModalGrupoRH from '../../offers/components/ModalGrupoRH';
import {droplet} from 'react-icons-kit/icomoon/droplet';

var Config = require('../../../config');

class TableResults extends Component {

  constructor(props, context) {
    super(props, context);
    
    this.deleteMsg = this.deleteMsg.bind(this);
    this.openModalValidation = this.openModalValidation.bind(this);

    this.state = {
      columns:[],
      lab_sections:[],
      disableGroupRh:true,
    };
  }

  componentDidMount() {
    this.props.onRef(this);

    var user_task = JSON.parse(sessionStorage.getItem("task_has_user_profiles"));
    user_task.map((user)=>{
      if(user.type !== undefined){
        if(user.type==='PRINT_RESULTS'){
          this.setState({
            disableGroupRh: false
          })
        }
      }
    })

    fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=DONATIONS_RESULT',{ 
      method: 'get',
      headers: new Headers({
         'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
         'Accept': 'application/json',
          'Content-Type': 'application/json',
      })
    })
    .then(res => {
          if(res.ok){
            return res.json();
          }else{
            res.text().then(function(error) {
              swal('¡Error', error, 'error');
            });
        }
    })
    .then(response => {
      if(response !== undefined){
        this.setState({ columns: response });
      }
    })

    fetch(Config.default.apiGateway.URL+'lab_sections/byUser?health_facilities_id='+sessionStorage.getItem("health_facilities_id"), {
      method : 'get',
      headers: new Headers({
        'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
        'Accept'        : 'application/json',
        'Content-Type'  : 'application/json'
      })
    })
    .then(res => {
          if(res.ok){
            return res.json();
          }else{
            res.text().then(function(error) {
              swal('¡Error', error, 'error');
            });
        }
    })
    .then(response => {
        this.setState({
          lab_sections: response
        });
    })
  }

  componentWillUnmount() {
    this.props.onRef(null)

  }

  //Mensaje de alerta, confirmar eliminacion
  deleteMsg(id,props){
    swal({
        title: '¿Está seguro?',
        text: '¿Desea eliminar este registro?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: '¡Si, Eliminar!',
        cancelButtonText: '¡No, Cancelar!',
        closeOnConfirm: true,
        closeOnCancel: true
    }, function (isConfirm) {
        if (isConfirm) {
          /*fetch(Config.default.apiGateway.URL+'offers/'+id,{ 
            method: 'delete',
            headers: new Headers({
               'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
               'Accept': 'application/json',
              'Content-Type': 'application/json',
            })
          })
          .then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
              });
            }})
          .then(res => {
              if(res !== undefined){
                swal('Buen Trabajo', 'Registro Eliminado','success');
                props.refresh();
              }console.log(res);
          })*/
        }
    });
  };

  showColumn(column_name){
    var i =0;
    if(this.props.columns.length > 0){
      for(i =0; i < this.props.columns.length;i++){
          if(this.props.columns[i]=== column_name){
          return false;
        }
      }

    }else{
      for(i =0; i < this.state.columns.length;i++){
        if(this.state.columns[i]=== column_name){
          return false;
        }
      }
      
    }

    return true;
  }

  filter(row){ 
    var res = false;
    if(
    row.donor_id.toString().indexOf(this.props.filterText.toUpperCase())!==-1 ||
    row.offers_id.toString().indexOf(this.props.filterText.toUpperCase())!==-1 ||
    row.donation_number.indexOf(this.props.filterText.toUpperCase())!==-1 ||
    row.donation_type.indexOf(this.props.filterText.toUpperCase())!==-1 ||
    row.extraction_type.indexOf(this.props.filterText.toUpperCase())!==-1 ||
    row.donor_name.indexOf(this.props.filterText.toUpperCase())!==-1)
      res = true;

    return res;
  }

  concatGroupRH(group_test){
    var res = "";

      if(group_test !== undefined && group_test!==null){
        if(group_test.RH==="POSITIVO"){
          res = group_test.group+'+'
        }else{
          res = group_test.group+'-';
        }
        if(res.length>0){
          if(group_test.lectina !== null){
            var position = 1;
            res = [res.slice(0, position),group_test.lectina, res.slice(position)].join('');
          }
        }
      }

    return res;
  }

  singleValidation(e, section, item){
    e.preventDefault();
    this.single_validation.handleShow(item.donation_id, section.lab_sections_id, section.name, item.samples_id);
  }

  getIconSectionColor(sections_color, lab_section_id){
    for(var i=0;i < sections_color.length;i++){
      if(sections_color[i].lab_section_id === lab_section_id){
        return sections_color[i].color;
      }
    }

    return "";
  }

  laboratory_print(e,item){
    e.preventDefault();

    fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+'&file_type=area_laboratory&extraction_type=',{ 
        method: 'get',
        headers: new Headers({
           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
           'Accept': 'application/json',
          'Content-Type': 'application/json',
        })
      })
      .then(res => {
              if(res.ok){
                return res.json();
              }else{
                res.text().then(function(result) {
                  swal('¡Error', result, 'error');
                });
              }})
      .then(async response => {
        if(response.res === 0){
          swal('¡Error!', "No se ha definido ningún formato de impresión", 'error');
        }else{
          this.waiting_modal.handleShow('Imprimiendo...');
          
          var obj ={};
          obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
          obj.id = item.donation_id;
          obj.file_type = "area_laboratory";
          obj.nEtiqueta = [0];

          var type = await this.props.getDocumentType(obj.file_type);

          var document;
          if(type.print_type === 'template'){
            document = await this.props.printDocumentTemplate(obj, type.print_automatically);
          }else if(type.print_type === 'external'){
            document = await this.props.printDocumentExternal(obj, type.print_automatically);
          }

          if(document !== undefined){
            this.waiting_modal.handleClose();
            this.setState({show:false});
          }else{
            this.waiting_modal.handleClose();
          }
        
          
        }
      })
  }

  openModalValidation(e, validate, donation_id, sections){
    e.preventDefault();
    if(validate === "PENDING"){
      
      var lab_sections = JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles"));
      var obj = [];
      var names = "";
      lab_sections.map((s)=>{
        if(s.validate_results){
          var indexSection = sections.findIndex((obj => obj.lab_section_id === s.lab_sections_id));

          if(indexSection !== -1){
            obj.push(s.lab_sections_id);
            
            names += sections[indexSection].lab_section_name+', '
          }
           
        }
      })
      names = names.slice(0, (names.length - 2));
   
      if(obj.length < lab_sections.length){
         swal({
              title: '¿Está seguro?',
              text: 'Las secciones permitidas para validar son '+names,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: '¡Si, Validar!',
              cancelButtonText: '¡No, Cancelar!',
              closeOnConfirm: true,
              closeOnCancel: true
          }, function (isConfirm) {
              if (isConfirm) {
                  
                  this.waiting_modal.handleShow("Validando Resultados...");
                  setTimeout(function(){
                    this.validateSection(donation_id, obj);
                  }.bind(this), 1000);
                  
              }
          }.bind(this));
      
      }else if(obj.length === lab_sections.length){
        
        this.waiting_modal.handleShow("Validando Resultados...");
        setTimeout(function(){
          this.validateSection(donation_id, obj);
        }.bind(this), 1000);
      }

    }else{
      swal('¡Error!', '¡No hay resultados pendientes por validar!', 'error');
    }
   
  }

  validateSection(donation_id, sections){
    
    fetch(Config.default.apiGateway.URL+'donations/validate_donation?donation_id='+donation_id+"&health_facilities_id="
      +sessionStorage.getItem("health_facilities_id"),{
      method :'POST',
      body:JSON.stringify(sections),
      headers: new Headers({
        'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
        'Accept'    : 'application/json',
        'Content-Type'  : 'application/json'
      }) 
    })
    .then(res => {
        this.waiting_modal.handleClose();
        if(res.ok){
          return res.json();
        }else{
          res.text().then(function(error) {
            swal('¡Error!', error, 'error');
          });
        }
    })
    .then(response => {
      if(response !== undefined){
        var msg = "<table class='table' style='text-align:left;'>"+
                  "<thead>"+
                    "<tr>"+
                      "<th style='text-align:center'>Sección</th>"+
                      "<th style='text-align:center'>Estatus</th>"+
                      "<th style='text-align:center'>Mensaje</th>"+
                    "</tr>"+
                  "</thead>"+
                  "<tbody>";
        for(var i =0;i < response.length;i++){
          msg += "<tr>"+
                    "<td>"+response[i].lab_section+"</td>"+
                    "<td>"+response[i].status.toUpperCase()+"</td>"+
                    "<td>"+response[i].message+"</td>"+
                  "</tr>";
        }
              
        msg += "</tbody></table>";
        
        swal({
          title: "Proceso Terminado",
          html:true,
          text: msg,
          type: 'success',
          //customClass: 'swal-wide',
        }, function (isConfirm) {
            if (isConfirm) {
              this.props.refresh();
            }else{
              return false;
            }
        }.bind(this));
      }
    })
  }

  openModalGrupoRH(e, item){
    e.preventDefault();

    var group_test_id = 0;
    if(item.group_test !== null){
      group_test_id = item.group_test.id;
    }
    this.modal_grupo_rh.handleShow(item.donor_id, item.offers_id, group_test_id, item.group_test, "");
    
  }

  //Contenido de la tabla
  render () {
    const { t } = this.props;
    return (
      <div>
        <Table responsive hover>
          <thead>
            <tr>
              <th hidden={this.showColumn('DONOR_ID')}>{t('content.results_donation.donor_number')}</th>
              <th hidden={this.showColumn('DONATION_NUMBER')}>{t('content.results_donation.donation_number')}</th>
              <th hidden={this.showColumn('OFFER_ID')}>{t('content.results_donation.offer_id')}</th>
              <th hidden={this.showColumn('DONATION_TYPE')}>{t('content.results_donation.donation_type')}</th>
              <th hidden={this.showColumn('EXTRACTION_TYPE')}>{t('content.results_donation.extraction_type')}</th>
              <th hidden={this.showColumn('DONOR_NAME')}>{t('content.results_donation.donor_name')}</th>
              <th hidden={this.showColumn('GROUP_RH_INITIAL')}>Grupo Inicial</th>
              <th hidden={this.showColumn('GROUP_RH')}>Grupo & RH</th>
              <th hidden={this.showColumn('REGISTER_DATE')}>{t('content.results_donation.timestamp')}</th>
              {
                this.state.lab_sections.map((item, index) =>{ 
                  return <th key={index}>{item.code}</th>
                }) 
              }
              <th hidden={this.showColumn('VALIDATED')} style={{textAlign:"center"}}>{t('content.results_donation.viable')}</th>
              <th width={125}></th>
            </tr>
          </thead>
          <tbody>
        
          {this.props.items.map( (obj, index) => (
              this.filter(obj.item) === true? 
              <tr key={index} >
                <td hidden={this.showColumn('DONOR_ID')}>{obj.item.donor_number}</td>
                <td hidden={this.showColumn('DONATION_NUMBER')}>{obj.item.donation_number}</td>
                <td hidden={this.showColumn('OFFER_ID')}>{obj.item.offers_id}</td>
                <td hidden={this.showColumn('DONATION_TYPE')}>{obj.item.donation_type}</td>
                <td hidden={this.showColumn('EXTRACTION_TYPE')}>{obj.item.extraction_type}</td>
                <td hidden={this.showColumn('DONOR_NAME')}>{obj.item.donor_name}</td>
                <td hidden={this.showColumn('GROUP_RH_INITIAL')}>
                  {
                    <a href="#" 
                    onClick={(e) => this.openModalGrupoRH(e,obj.item)} 
                    >
                    {obj.item.group_test != null?
                      this.concatGroupRH(obj.item.group_test)
                    :<SvgIcon size={25} icon={droplet} title="Grupo & RH"/>
                    }
                  </a>}
                </td>
                <td hidden={this.showColumn('GROUP_RH')}>{obj.item.group_rh}</td>
                <td hidden={this.showColumn('REGISTER_DATE')}>
                  <Moment format="DD/MM/YYYY">{obj.item.timestamp_date}</Moment>{' '}
                  <Moment parse="HH:mm" format="h:mm a">{obj.item.timestamp_hour}</Moment>
                </td>
                {this.state.lab_sections.map((section, index) =>{ 
                    return  <td key={"td_"+section.name}>
                      {obj.sections_color[index].draw ?
                        <a href="" title={section.name} 
                          onClick={(e) => this.singleValidation(e, section, obj.item)} 
                          style={{color:this.getIconSectionColor(obj.sections_color,section.lab_sections_id)}}>
                          <SvgIcon size={25} icon={clipboard}/>
                        </a>
                      :null}
                    </td>
                })}
                <td hidden={this.showColumn('VALIDATED')} style={{textAlign:"center"}} align="center">
                   {obj.item.validation==="ACCEPTED"?
                      <button style={{fontSize:".5em", textAlign:"center"}} 
                        onClick={(e) => this.openModalValidation(e,obj.item.validation, obj.item.donation_id, obj.sections_color)} align="center" 
                        className="btn btn-success" type="button">
                        <SvgIcon icon={checkmark}/>
                      </button>
                    :obj.item.validation==="REJECT" || obj.item.validation==="DISCREPANT"?
                      <button style={{fontSize:".5em"}} className="btn btn-danger" type="button" 
                        onClick={(e) => this.openModalValidation(e,obj.item.validation, obj.item.donation_id, obj.sections_color)}>
                        <SvgIcon icon={cross}/>
                      </button>
                    : <button style={{fontSize:".5em",backgroundColor:"orange",color:"white"}} className="btn" 
                        type="button" onClick={(e) => this.openModalValidation(e,obj.item.validation, obj.item.donation_id, obj.sections_color)}>
                        <SvgIcon icon={minus}/>
                      </button>
                  }
                </td>
                <td width={135}>
                  <FloatingActionButton backgroundColor={'#ededed'}
                  iconStyle={{height: 33, width: 33}} mini={true} style={{marginLeft:"5px"}} 
                  disabled={!this.props.task_results_donation.create ? true : obj.item.samples_id !==0}
                  containerElement={!this.props.task_results_donation.create ? 
                      <div></div> 
                    :obj.item.samples_id === 0 ? 
                      obj.item.group_test === null ?
                        <Link  to={'results_donation/new/'+obj.item.donation_id+'/0'}/>
                      :  <Link to={'results_donation/new/'+obj.item.donation_id+'/'+obj.item.group_test.id}/>
                    : <div></div>}>
                    <ContentAdd className="icon-align" />
                  </FloatingActionButton>

                  <FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} mini={true} style={{marginLeft:"5px"}} 
                  disabled={!this.props.task_results_donation.update ? true : obj.item.samples_id === 0}
                  containerElement={!this.props.task_results_donation.update ? 
                      <div></div> 
                      : obj.item.samples_id !== 0 ? 
                        obj.item.group_test === null ?
                          <Link to={'results_donation/edit/'+obj.item.samples_id+'/'+obj.item.donation_id+'/0'}/>
                        : 
                          <Link to={'results_donation/edit/'+obj.item.samples_id+'/'+obj.item.donation_id+'/'+obj.item.group_test.id}/> 
                      : <div></div>}>
                    <SvgIcon icon={pencil2} className="icon-align"/>
                  </FloatingActionButton>

                  <FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} onClick={(e) => this.laboratory_print(e, obj.item)}
                      mini={true} style={{marginLeft:"5px"}} disabled={obj.item.samples_id ===0 || this.state.disableGroupRh}>
                    <SvgIcon icon={print} className="icon-align"/>
                  </FloatingActionButton>
                </td>
              </tr>:null
              ))}
          </tbody>
        </Table>
        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
        <ModalSingleValidation {...this.props} onRef={ref => (this.single_validation = ref)} refresh={this.props.refresh} state={this.props.state}/>
        <ModalGrupoRH {...this.props} onRef={ref => (this.modal_grupo_rh = ref)} refresh={this.props.refresh}/>
      </div>
    );
  }
}

export default translate('translations')(TableResults)